import { useState } from 'react';

import { cn } from '@/lib/utils';

interface InitialsAvatarProps {
  name: string;
  src?: string | null;
  className?: string;
}

/** Up-to-two-letter uppercase initials for a name. */
export function initialsOf(name: string): string {
  return name
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

/** Shows an image, falling back to the name's initials (and on load error). */
export function InitialsAvatar({ name, src, className }: InitialsAvatarProps) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-muted font-medium text-muted-foreground text-xs',
        className,
      )}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initialsOf(name)
      )}
    </div>
  );
}
